import {SSD, STAGE_LOCATION_TYPE} from "./Constants";
import {roundTo2Decimals} from "../util/Util";
import {API_METRIC_NAME} from "../workstationMetrics/network/apiMetricNames";
import {LOGGED_OUT} from "./EntityStatusManager";

const OVERFLOW_LOCATION_SUFFIX = " (Overflow)";

/**
 * Returns staging location of route.
 * Pre-requisite: transformStagingLocations should be executed on route before this method.
 *
 * @param rswsRoute - response route obj from rsws
 */
export function getRouteStagingLocation(rswsRoute) {
    if(rswsRoute.stagingLocations.length){
        return rswsRoute.stagingLocations.map(location => location.displayLabel).join(", ");
    }
    return "...";
}

/**
 * Returns staging location of cart.
 * Pre-requisite: transformStagingLocations should be executed on route before this method.
 * Currently this is applicable for AMZL only.
 *
 * @param route - response route obj from rsws
 * @param cart - station capability
 */
export function getCartStagingLocation(route, cart) {
    if (cart.stagingLocation) {
        return getDisplayLabel(cart.stagingLocation);
    } else if (cart.stageTime && route) {
        return route.stagingLocation;
    }
    return "...";
}

/**
 * Returns parsed staging locations list for route.
 * @param rswsRoute
 * @return {*[]|{displayLabel: (null|string|*), label: (null|string|*), type: string}[]|*}
 */
export function transformStagingLocations(rswsRoute) {
    if (Array.isArray(rswsRoute.stagingLocations) && rswsRoute.stagingLocations.length) {
        return rswsRoute.stagingLocations.map(location => {
            return {
                label: location.label,
                type: location.type,
                displayLabel: getDisplayLabel(location)
            }
        })
    } else if (rswsRoute.stagingLocation && rswsRoute.stagingLocation !== "...") {
        return [{
            label: rswsRoute.stagingLocation,
            displayLabel: rswsRoute.stagingLocation,
            type: STAGE_LOCATION_TYPE.NORMAL,
        }]
    }
    return [];
}

export function getDisplayLabel(location) {
    if (location.type === STAGE_LOCATION_TYPE.OVERFLOW) {
        return `${location.label}${OVERFLOW_LOCATION_SUFFIX}`
    } else {
        return location.label;
    }
}

/**
 * Extracts stagelist id from carts object.
 * NOTE: SSD routes have only one cart.
 * @param route
 * @param capability
 * @return {null|*}
 */
export function extractStageListId(route, capability) {
    if (capability === SSD && Array.isArray(route.carts)) {
        let stageListIds = route.carts.map(cart => cart.stageListId).filter(Boolean);

        //filter duplicate ids
        stageListIds = stageListIds.filter(function(item, pos) {
            return stageListIds.indexOf(item) === pos;
        })
        return stageListIds.length ? stageListIds[0] : null;
    }
    return null;
}

/**
 * Extracts collaborative metric data to populate from station level metric
 * NOTE: Each station have separate metric list
 * @param stationList
 * @return {metric}
 */
export function getPickStationMetrics(stationList) {
    const metrics = {
        totalStation: 0,
        averagePickTime: 0,
        averagePodGap: 0,
        averagePileOn: 0,
        totalActiveStation : 0,
        TotalLoggedOutStation : 0
    }
    const data = {
        totalPodGap: 0,
        totalPileOn: 0,
        totalPickTaktTime: 0
    }

    stationList.forEach(station => {
        /** Station level metrics */
        if (station.stationID !== "ALL") {
            metrics.totalStation++;
            data.totalPodGap = data.totalPodGap + (station[API_METRIC_NAME.podGap] ? station[API_METRIC_NAME.podGap] : 0);
            data.totalPileOn = data.totalPileOn + (station[API_METRIC_NAME.packagePileOnRate] ?station[API_METRIC_NAME.packagePileOnRate] : 0);
            data.totalPickTaktTime = data.totalPickTaktTime + (station[API_METRIC_NAME.pickTaktTime] ?station[API_METRIC_NAME.pickTaktTime] : 0);
            if(station[API_METRIC_NAME.stationStatus] && station[API_METRIC_NAME.stationStatus] !== LOGGED_OUT) {
                metrics.totalActiveStation++;
            }
        }
    });

    metrics.TotalLoggedOutStation = metrics.totalStation - metrics.totalActiveStation;
    metrics.averagePickTime = (data.totalPickTaktTime && metrics.totalStation) ? roundTo2Decimals(parseFloat(data.totalPickTaktTime/metrics.totalStation)) : 0;
    metrics.averagePileOn = (data.totalPileOn && metrics.totalStation) ? roundTo2Decimals(parseFloat(data.totalPileOn/metrics.totalStation)) : 0;
    metrics.averagePodGap = (data.totalPodGap && metrics.totalStation) ? roundTo2Decimals(parseFloat(data.totalPodGap/metrics.totalStation)) : 0;
    return metrics
}


// WEBPACK FOOTER //
// ./src/components/util/DataTransformUtil.js